<template>
  <a
    href=""
    :class="['edit_opt_box', {inactive: disabled}]"
    @click.prevent="handleClick"
  >
    <h3>{{ $_translations.value[text] }}</h3>

    <i class="fas fa-chevron-right"></i>
  </a>
</template>

<script setup>
const emits = defineEmits(['click']);

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const handleClick = () => {
  if (props.disabled) { return; }

  emits('click');
};
</script>
